export default "__VITE_ASSET__618dcdfc__"